var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tooltip',{attrs:{"content":"返回上一页","placement":"bottom","effect":"light"}},[_c('div',{staticClass:"idea",on:{"click":function($event){return _vm.goBack()}}},[_c('div',{staticClass:"blue"}),_c('div',{staticClass:"yellow"}),_c('div',{staticClass:"red"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }